import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
/**
  * Usage of <app-search/> requires adding a wrapper div with `position: relative`.
  *
  * Inside <app-search/>, there is a `.position-for-search` class, which applies `position: absolute`
  * and additional positioning properties.
  *
  * Example:
  * <div class="relative">
  *   <app-search/>
  * </div>
  */
export class SearchComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() placeholder = '';
  @Output() searchEmitter = new EventEmitter<string>();
  @Output() cancelEmitter = new EventEmitter<void>();
  private _destroyStream: Subject<void> = new Subject<void>();
  searchControl: FormControl<string>;
  showSearch = false;

  ngOnInit(): void {
    this.initSearchControl();
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  cancel(): void {
    this.searchControl.patchValue('');
    this.showSearch = false;
    this.cancelEmitter.emit();
  }

  private initSearchControl(): void {
    this.searchControl = new FormControl<string>('');
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this._destroyStream))
      .subscribe((value) => {
        this.searchEmitter.emit(value);
      });
  }
}
